import { memo } from 'react';
import { IUniqkeyImageProp } from '../interfaces';

const StripeImage = (props: IUniqkeyImageProp) => {
  const { width = 343, height = 36 } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 343 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width={width} height={height} fill="#5D6169" />
    </svg>
  );
};

export default memo(StripeImage);
